import { render, staticRenderFns } from "./komuni.vue?vue&type=template&id=44ac7b3c&scoped=true&"
import script from "./komuni.vue?vue&type=script&lang=js&"
export * from "./komuni.vue?vue&type=script&lang=js&"
import style0 from "./komuni.vue?vue&type=style&index=0&id=44ac7b3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ac7b3c",
  null
  
)

export default component.exports